import { NavLink, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import styles from "./NavigationBottom.module.css";
import clsx from "clsx";
import { BsChatText, BsGift } from "react-icons/bs";
import { MdOutlineStarOutline } from "react-icons/md";
import { PiChartLineUp } from "react-icons/pi";
import { selectIsChatOpen } from "../../redux/chat/selectors";
import { useSelector } from "react-redux";
import useTooltip from "../../utils/useTooltip";
import Tooltip from "../sharedComponents/Tooltip/Tooltip";
import { IoCarSportSharp } from "react-icons/io5";
import { GiBookCover } from "react-icons/gi";
import { LuCircleHelp } from "react-icons/lu";
import TutorialNav from "./TutorialNav/TutorialNav";
import { selectUser } from "../../redux/auth/selectors.js";
import ChangeLog from "./ChangeLog/ChangeLog.jsx";
import { useState } from "react";
import Modal from "../Modals/Modal/Modal.jsx";
import FirstTimeEnterModal from "../FirstTimeEnterModal/FirstTimeEnterModal.jsx";

export default function NavigationBottom() {
  const navigate = useNavigate();
  const chatIsOpen = useSelector(selectIsChatOpen);
  const userData = useSelector(selectUser);
  const pages = userData?.access_pages?.pages ?? {};
  const hasAccess = path => !!pages[path];
  const [isFirstTimeEnterModalOpen, setIsFirstTimeEnterModalOpen] =
    useState(false);

  const [isFirstClickOnAcademy, setIsFirstClickOnAcademy] = useState(
    localStorage.getItem("ACADEMY_FIRST_CLICK_KEY ") === "true"
  );

  useEffect(() => {
    if (!isFirstClickOnAcademy) {
      setIsFirstTimeEnterModalOpen(true);
    }
  }, [isFirstClickOnAcademy]);

  // Після закриття модалки запам'ятовуємо, щоб вона більше не показувалась
  const closeFirstTimeEnterModal = () => {
    localStorage.setItem("ACADEMY_FIRST_CLICK_KEY ", "true");
    setIsFirstTimeEnterModalOpen(false);
    setIsFirstClickOnAcademy(true);
  };

  const {
    tooltipPosition,
    isTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    tooltipText,
    handleClick,
  } = useTooltip();

  return (
    <>
      <nav
        className={clsx(styles.navigation, {
          [styles.navigationChatOpen]: chatIsOpen,
        })}
      >
        <ul className={styles.bottomNavContainer}>
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "ACADEMY")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={() => {
              handleClick();
              localStorage.setItem("ACADEMY_FIRST_CLICK_KEY ", "true");
              setIsFirstClickOnAcademy(true);
              // navigate("https://mechorbit.com/ua/academy?module=settings&chapter=1&step=1&lang=uk");
            }}
          >
            <NavLink
              to="https://mechorbit.com/ua/academy?module=settings&chapter=1&step=1&lang=uk"
              target="_blank"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: false,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={`${styles.iconContainer} ${styles.iconHelp}`}>
                <LuCircleHelp className={styles.iconChart} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                  [styles.firstClick]: !isFirstClickOnAcademy,
                })}
              >
                ACADEMY
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>

          {/* <li>
          <TutorialNav />
        </li> */}
          <li>
            <ChangeLog />
          </li>
          {/* {hasAccess("/help") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "База знань")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/help"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: false,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={`${styles.iconContainer} ${styles.iconHelp}`}>
                <LuCircleHelp className={styles.iconChart} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                База знань
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )}
        {hasAccess("/connections") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "Звернення")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/connections"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: true,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={styles.iconContainer}>
                <BsChatText className={styles.iconChart} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                Звернення
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )}
        {hasAccess("/recommendations") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "Рекомендації")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/recommendations"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: true,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={styles.iconContainer}>
                <IoCarSportSharp className={styles.iconChart} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                Рекомендації
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )}
        {hasAccess("/proficiency") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "Маркетинг")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/proficiency"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: true,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={styles.iconContainer}>
                <PiChartLineUp className={styles.iconChart} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                Маркетинг
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )}
        {hasAccess("/rating") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "Рейтинг")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/rating"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: true,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={styles.iconContainer}>
                <MdOutlineStarOutline className={styles.iconRating} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                Рейтинг
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )}
        {hasAccess("/bonuses") && (
          <li
            className={styles.navItem}
            onMouseEnter={e => handleMouseEnter(e, "Мій бонус")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <NavLink
              to="/bonuses"
              className={({ isActive }) =>
                clsx(styles.navLink, {
                  [styles.active]: isActive,
                  [styles.disabled]: true,
                  [styles.navWithChat]: chatIsOpen,
                })
              }
            >
              <div className={styles.iconContainer}>
                <BsGift className={styles.iconBonus} />
              </div>
              <span
                className={clsx(styles.linkText, {
                  [styles.hidden]: chatIsOpen,
                  [styles.visible]: !chatIsOpen,
                })}
              >
                Мій бонус
              </span>
            </NavLink>
            <Tooltip
              isVisible={isTooltipVisible && chatIsOpen}
              position={tooltipPosition}
              text={tooltipText}
            />
          </li>
        )} */}
        </ul>
      </nav>

      {isFirstTimeEnterModalOpen && (
        <Modal
          isOpen={isFirstTimeEnterModalOpen}
          onClose={closeFirstTimeEnterModal}
        >
          <FirstTimeEnterModal onClose={closeFirstTimeEnterModal} />
        </Modal>
      )}
    </>
  );
}
